import { Component, OnInit, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PipeModule } from 'src/app/pipe.module';
import { SellerCompanyLogoModule } from '../seller-company-logo/seller-company-logo.module';
import { DxGalleryModule, DxPopupModule } from 'devextreme-angular';
import { environment } from 'src/environments/environment';
import { UserService } from '../../services/user/user.service';
import { AllocationService } from '../../services/listing/allocation.service';
import { FeatureFlagsService } from 'src/app/shared/services/featureFlags.service';
import { CartService } from 'src/app/shared/services/cart/cart.service';

@Component({
  selector: 'app-listing-details',
  templateUrl: './listing-details.component.html',
  styleUrls: ['./listing-details.component.scss'],
})
export class ListingDetailsComponent implements OnInit {
  @Input() listing: any;
  imagePopupVisible = false;
  currentImage: any;
  listingExpiryDates = [];
  openProductSpecsPopup: boolean = false;
  hydraEnabled = environment.hydraEnabled;
  relevantAllocation: any;
  cadenceAmount: any;
  allocationMessage: any;
  user: any;
  shippingOption: any;

  constructor(
    private userService: UserService,
    private allocationService: AllocationService,
    private featureFlagsService: FeatureFlagsService,
    private cartService: CartService,
  ) {}

  ngOnInit() {
    // Back end event raise for Kibana
    if (this.listing.lots.length > 2) {
      this.listingExpiryDates.push(this.listing.lots.at(-1)?.expiry_date);
      this.listingExpiryDates.push(' - ');
      this.listingExpiryDates.push(this.listing.lots[0]?.expiry_date);
    }

    const shippingExpeditedCheckboxMode = this.featureFlagsService.get(
      'shipping_expedited_checkbox_mode',
    );
    this.cartService.get(false).subscribe(data => {
      const primaryOptions = this.listing.options.filter(o => o.primary === 1);
      const listingSpecificOptions = this.listing.options.filter(
        o => o.primary === 0,
      );
      if (shippingExpeditedCheckboxMode) {
        if (data.expedited) {
          this.shippingOption = listingSpecificOptions[0] || primaryOptions[0];
        } else {
          this.shippingOption = primaryOptions[0] || listingSpecificOptions[0];
        }
      } else {
        this.shippingOption = this.listing.primary_option;
      }
    });

    this.userService.logEvent('view_listing_details', {
      listing_id: this.listing.id,
      listing_name: this.listing.name,
    });
    this.getUserInfo();
  }

  getUserInfo() {
    this.userService.getMe().subscribe(result => {
      this.user = result.data;
      const deaAllocation = this.listing.allocations.find(
        allocation => allocation.dea === this.user.primary_facility?.dea_number,
      );
      const globalAllocation = this.listing.allocations.find(
        allocation => allocation.global_allocation,
      );
      this.relevantAllocation = deaAllocation || globalAllocation;
      if (this.relevantAllocation) {
        this.getAllocationRemaining();
      }
    });
  }

  getAllocationRemaining() {
    if (this.relevantAllocation) {
      this.allocationService
        .getAllocations(this.relevantAllocation.id)
        .subscribe(
          result => {
            this.relevantAllocation = result.data;
            let remainingAllocation =
              this.relevantAllocation.remaining > 0
                ? this.relevantAllocation.remaining
                : 0;
            const isDailyAllocation =
              this.relevantAllocation.cadence === 0 &&
              this.relevantAllocation.days === 1;
            const allocationUnit = isDailyAllocation ? 'every' : 'each';
            this.cadenceAmount =
              this.relevantAllocation.cadence === 1
                ? 'month'
                : `${this.relevantAllocation.days} ${isDailyAllocation ? 'day' : 'days'}`;
            this.allocationMessage = `${remainingAllocation} packs remaining in your limit of ${this.relevantAllocation.packs_quantity} ${allocationUnit} ${this.cadenceAmount}.`;
          },
          error => {
            console.error('Error fetching allocation:', error);
            this.relevantAllocation = null;
          },
        );
    }
  }

  openProductSpecs() {
    this.openProductSpecsPopup = true;
  }

  documentOpen = document => window.open(document.url, '_blank').focus();
  showImage(image) {
    this.currentImage = image;
    this.imagePopupVisible = true;
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SellerCompanyLogoModule,
    PipeModule,
    DxPopupModule,
    DxGalleryModule,
  ],
  declarations: [ListingDetailsComponent],
  exports: [ListingDetailsComponent],
})
export class ListingDetailsModule {}
